import React from 'react';
import './StaticPages.css';

const AboutMe = () => {
  return (
    <div className="static-page">
      <h1>O meni</h1>
      <div className="content">
        <section className="about-me-intro">
          <h2>Ko stoji iza bloga Jaka kao Majka?</h2>
          <p>
            Zdravo! Ja sam mama koja je, iz ljubavi prema pisanju i želje da pomažem drugima, 
            odlučila da podelim lična iskustva iz trudnoće, majčinstva i svakodnevnog života sa decom. 
            Verujem da nijedna mama ne treba da prolazi kroz izazove sama – zato sam stvorila ovo 
            sigurno, toplo mesto na internetu.
          </p>
        </section>

        <section className="about-blog">
          <h2>Zašto Jaka kao Majka?</h2>
          <p>
            Blog „Jaka kao Majka" nastao je iz lične potrebe – da pronađem, ali i pružim podršku. 
            Svaka mama je jaka, iako ponekad to zaboravimo. Kroz deljenje iskustava, saveta i 
            stvarnih priča, želim da ti pokažem da nisi sama. Ovde ćeš pronaći iskrene tekstove 
            koji osnažuju, inspirišu i povezuju.
          </p>
        </section>

        <section className="my-mission">
          <h2>Moja misija</h2>
          <p>
            Moja misija je da izgradim zajednicu majki koje se međusobno podržavaju. Ovaj blog je 
            mesto gde možeš:
          </p>
          <ul>
            <li>Pronaći proverene informacije o trudnoći, porođaju, dojenju, ishrani i razvoju deteta</li>
            <li>Pročitati lična iskustva iz prvih dana majčinstva – bez filtera</li>
            <li>Dobiti podršku i razumevanje od drugih mama koje prolaze kroz slične faze</li>
            <li>Osetiti da nisi sama – ni u izazovima, ni u radostima</li>
          </ul>
        </section>

        <section className="contact">
          <h2>Pridruži mi se</h2>
          <p>
            Ako želiš da podeliš svoju priču, postaviš pitanje ili samo popričaš sa nekim ko 
            razume – piši mi. Tu sam da slušam.
          </p>
          <ul>
            <li>Email: jakakaomajka@gmail.com</li>
            <li>Instagram: @jakakaomajka</li>
            <li>Facebook: Jaka kao Majka</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AboutMe; 